import { render, staticRenderFns } from "./two-factor-auth.vue?vue&type=template&id=79b7aafe&scoped=true"
import script from "./two-factor-auth.vue?vue&type=script&lang=js"
export * from "./two-factor-auth.vue?vue&type=script&lang=js"
import style0 from "./two-factor-auth.vue?vue&type=style&index=0&id=79b7aafe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b7aafe",
  null
  
)

export default component.exports